import { useAtomValue, useSetAtom } from 'jotai';
import VideoThumbnailCard from '../../v2/components/VideoThumbnailCard';
import TRC_CONTENT from '@/constants/trcContentType';
import GoodTimesFontText from './goodTimesFontText';
import { useNavigate } from 'react-router-dom';
import { userInfoAtom } from '@/data/atoms/utilsAtoms';
import checkApiStatus from '@/component/SubscripStatus';
import { TRC_ROUTES } from '@/TRC/constants/trcRoutes';
import { buildRoutes } from '@/service/buildRoutes';

const TRCHorizontalScrollComponent = ({
	contents,
	route,
	showButton = true,
	className,
	cardMaxWidth = '352px',
	fixedWidth = false,
	basePath
}) => {
	const navigate = useNavigate();
	const userData = useAtomValue(userInfoAtom);
	const setUserData = useSetAtom(userInfoAtom);
	const redirect = useNavigate();
	const cardWidth = fixedWidth ? { width: cardMaxWidth } : { maxWidth: cardMaxWidth };

	const handlePlayerVideo = async id => {
		const apistatus = await checkApiStatus(userData.token, setUserData);

		if (userData.token) {
			if (apistatus) {
				redirect(buildRoutes.toPlayerPage(id));
			} else {
				redirect(buildRoutes.toPlans());
			}
		} else {
			redirect(buildRoutes.toSignUp());
		}
	};
	return (
		<div className={`w-full py-1 px-1 ${className}`}>
			<div className="d-flex overflow-auto" style={{ gap: '16px' }}>
				{contents?.map(num => {
					const isRoutedContent = Boolean(num.fileType || basePath);
					return (
						<div key={num._id || num.title}>
							<VideoThumbnailCard
								content={num}
								route={(num.route || route).toLowerCase()}
								basePath={num.basePath || basePath}
								showSaveButton={false}
								showAddToPlaylist={false}
								{...(isRoutedContent ? { type: TRC_CONTENT.TRC } : {})}
								handlePlayerVideo={() => handlePlayerVideo(num._id)}
								customStyles={{
									...cardWidth,
									aspectRatio: '16/9'
								}}
							/>
						</div>
					);
				})}
			</div>
			{showButton && (
				<div className="d-flex w-100 justify-content-end mt-1">
					<button
						className="bg-transparent border-0"
						onClick={() => navigate(basePath ? `/${basePath}` : buildRoutes.toTRCDynamicRoute(route.toLowerCase()))}
					>
						<GoodTimesFontText color="#3cb4e4">View All</GoodTimesFontText>
					</button>
				</div>
			)}
		</div>
	);
};

export default TRCHorizontalScrollComponent;
